export function clearExtractsWindow() {
  return {
    type: 'CLEAR_EXTRACTS_WINDOW'
  }
}

export function initExtractsWindow() {
  return {
    type: 'INIT_EXTRACTS_WINDOW'
  }
}

export function clearProfileWindow() {
  return {
    type: 'CLEAR_PROFILE_WINDOW'
  }
}

export function initProfileWindow() {
  return {
    type: 'INIT_PROFILE_WINDOW'
  }
}

export function clearInventoryWindow() {
  return {
    type: 'CLEAR_INVENTORY_WINDOW'
  }
}

export function initInventoryWindow() {
  return {
    type: 'INIT_INVENTORY_WINDOW'
  }
}

export function clearPatientFlagsWindow() {
  return {
    type: 'CLEAR_PATIENT_FLAGS_WINDOW'
  }
}

export function initPatientFlagsWindow() {
  return {
    type: 'INIT_PATIENT_FLAGS_WINDOW'
  }
}

export function clearUserManagementWindow() {
  return {
    type: 'CLEAR_USER_MANAGEMENT_WINDOW'
  }
}

export function initUserManagementWindow() {
  return {
    type: 'INIT_USER_MANAGEMENT_WINDOW'
  }
}

export function clearTreatmentPlanContainer() {
  return {
    type: 'CLEAR_TREATMENT_PLAN_WINDOW'
  }
}

export function initTreatmentPlanContainer() {
  return {
    type: 'INIT_TREATMENT_PLAN_WINDOW'
  }
}

export function clearAccountManagementWindow() {
  return {
    type: 'CLEAR_ACCOUNT_MANAGEMENT_WINDOW'
  }
}

export function initAccountManagementWindow() {
  return {
    type: 'INIT_ACCOUNT_MANAGEMENT_WINDOW'
  }
}

export function clearQuestionWindow() {
  return {
    type: 'CLEAR_QUESTION_WINDOW'
  }
}

export function initQuestionWindow() {
  return {
    type: 'INIT_QUESTION_WINDOW'
  }
}

export function clearQuestionnairesWindow() {
  return {
    type: 'CLEAR_QUESTIONNAIRE_WINDOW'
  }
}

export function initQuestionnairesWindow() {
  return {
    type: 'INIT_QUESTIONNAIRES_WINDOW'
  }
}

export function clearMessagingWindow() {
  return {
    type: 'CLEAR_MESSAGING_WINDOW'
  }
}

export function initMessagingWindow() {
  return {
    type: 'INIT_MESSAGING_WINDOW'
  }
}

export function clearProviderWindow() {
  return {
    type: 'CLEAR_PROVIDER_WINDOW'
  }
}

export function initProviderWindow() {
  return {
    type: 'INIT_PROVIDER_WINDOW'
  }
}

export function initAdminDisplay() {
  return {
    type: 'INIT_ADMIN_DISPLAY'
  }
}

export function clearAdminDisplay() {
  return {
    type: 'CLEAR_ADMIN_DISPLAY'
  }
}

export function clearPharmacyExtractsWindow() {
  return {
    type: 'CLEAR_PHARMACYEXTRACTS_WIDGET'
  }
}

export function initPharmacyExtractsWindow() {
  return {
    type: 'INIT_PHARMACYEXTRACTS_WIDGET'
  }
}

export function clearPanelsWindow() {
  return {
    type: 'CLEAR_PANELS_WIDGET'
  }
}

export function initPanelsWindow() {
  return {
    type: 'INIT_PANELS_WIDGET'
  }
}

export function clearPharmacyProfilesWindow() {
  return {
    type: 'CLEAR_PHARMACYPROFILES_WIDGET'
  }
}

export function initPharmacyProfilesWindow() {
  return {
    type: 'INIT_PHARMACYPROFILES_WIDGET'
  }
}

export function clearClinicWindow() {
  return {
    type: 'CLEAR_CLINIC_WIDGET'
  }
}

export function initClinicWindow() {
  return {
    type: 'INIT_CLINIC_WIDGET'
  }
}

export function clearProtocolsWindow() {
  return {
    type: 'CLEAR_PROTOCOLS_WIDGET'
  }
}

export function initProtocolsWindow() {
  return {
    type: 'INIT_PROTOCOLS_WIDGET'
  }
}

export function clearEntDilutionsWindow() {
  return {
    type: 'CLEAR_ENTDILUTIONS_WIDGET'
  }
}

export function initEntDilutionsWindow(patientId) {
  return {
    type: 'INIT_ENTDILUTIONS_WIDGET',
    patientId
  }
}

export function clearBackupsWindow() {
  return {
    type: 'CLEAR_BACKUPS_WIDGET'
  }
}

export function initBackupsWindow(patientId) {
  return {
    type: 'INIT_BACKUPS_WIDGET',
    patientId
  }
}

export function clearClickLogWindow() {
  return {
    type: 'CLEAR_CLICKLOG_WINDOW'
  }
}

export function initClickLogWindow(patientId) {
  return {
    type: 'INIT_CLICKLOG_WINDOW',
    patientId
  }
}

export function clearApiLogWindow() {
  return {
    type: 'CLEAR_APILOG_WIDGET'
  }
}

export function initApiLogWindow(patientId) {
  return {
    type: 'INIT_APILOG_WIDGET',
    patientId
  }
}

export function clearPrescriptionPanelsWindow() {
  return {
    type: 'CLEAR_PRESCRIPTIONPANELS_WIDGET'
  }
}

export function initPrescriptionPanelsWindow(patientId) {
  return {
    type: 'INIT_PRESCRIPTIONPANELS_WIDGET',
    patientId
  }
}

export function clearVisitHistoryWindow() {
  return {
    type: 'CLEAR_VISITHISTORY_WIDGET'
  }
}

export function initVisitHistoryWindow(patientId) {
  return {
    type: 'INIT_VISITHISTORY_WIDGET',
    patientId
  }
}
